[
  { "code": "AF", "nationality": "Afghan" },
  { "code": "AL", "nationality": "Albanais" },
  { "code": "DZ", "nationality": "Algérien" },
  { "code": "AS", "nationality": "Samoan Américain" },
  { "code": "AD", "nationality": "Andorran" },
  { "code": "AO", "nationality": "Angolais" },
  { "code": "AI", "nationality": "Anguillais" },
  { "code": "AG", "nationality": "Antiguayen ou Barbudien" },
  { "code": "AR", "nationality": "Argentin" },
  { "code": "AM", "nationality": "Arménien" },
  { "code": "AU", "nationality": "Australien" },
  { "code": "AT", "nationality": "Autrichien" },
  { "code": "AZ", "nationality": "Azerbaïdjanais" },
  { "code": "BS", "nationality": "Bahaméen" },
  { "code": "BH", "nationality": "Bahreïnien" },
  { "code": "BD", "nationality": "Bangladeshi" },
  { "code": "BB", "nationality": "Barbadien" },
  { "code": "BY", "nationality": "Biélorusse" },
  { "code": "BE", "nationality": "Belge" },
  { "code": "BZ", "nationality": "Bélizien" },
  { "code": "BJ", "nationality": "Béninois" },
  { "code": "BM", "nationality": "Bermudien" },
  { "code": "BT", "nationality": "Bhoutanais" },
  { "code": "BO", "nationality": "Bolivien" },
  { "code": "BA", "nationality": "Bosniaque ou Herzégovinien" },
  { "code": "BW", "nationality": "Botswanais" },
  { "code": "BR", "nationality": "Brésilien" },
  { "code": "BN", "nationality": "Brunéien" },
  { "code": "BG", "nationality": "Bulgare" },
  { "code": "BF", "nationality": "Burkinabé" },
  { "code": "BI", "nationality": "Burundais" },
  { "code": "KH", "nationality": "Cambodgien" },
  { "code": "CM", "nationality": "Camerounais" },
  { "code": "CA", "nationality": "Canadien" },
  { "code": "CV", "nationality": "Cap-Verdien" },
  { "code": "CF", "nationality": "Centrafricain" },
  { "code": "TD", "nationality": "Tchadien" },
  { "code": "CL", "nationality": "Chilien" },
  { "code": "CN", "nationality": "Chinois" },
  { "code": "CO", "nationality": "Colombien" },
  { "code": "KM", "nationality": "Comorien" },
  { "code": "CG", "nationality": "Congolais" },
  { "code": "CR", "nationality": "Costaricain" },
  { "code": "HR", "nationality": "Croate" },
  { "code": "CU", "nationality": "Cubain" },
  { "code": "CY", "nationality": "Chypriote" },
  { "code": "CZ", "nationality": "Tchèque" },
  { "code": "DK", "nationality": "Danois" },
  { "code": "DJ", "nationality": "Djiboutien" },
  { "code": "DM", "nationality": "Dominiquais" },
  { "code": "DO", "nationality": "Dominicain" },
  { "code": "EC", "nationality": "Équatorien" },
  { "code": "EG", "nationality": "Égyptien" },
  { "code": "SV", "nationality": "Salvadorien" },
  { "code": "GQ", "nationality": "Équato-Guinéen" },
  { "code": "ER", "nationality": "Érythréen" },
  { "code": "EE", "nationality": "Estonien" },
  { "code": "ET", "nationality": "Éthiopien" },
  { "code": "FJ", "nationality": "Fidjien" },
  { "code": "FI", "nationality": "Finlandais" },
  { "code": "FR", "nationality": "Français" },
  { "code": "GA", "nationality": "Gabonais" },
  { "code": "GM", "nationality": "Gambien" },
  { "code": "GE", "nationality": "Géorgien" },
  { "code": "DE", "nationality": "Allemand" },
  { "code": "GH", "nationality": "Ghanéen" },
  { "code": "GR", "nationality": "Grec" },
  { "code": "GD", "nationality": "Grenadin" },
  { "code": "GT", "nationality": "Guatémaltèque" },
  { "code": "GN", "nationality": "Guinéen" },
  { "code": "GW", "nationality": "Bissau-Guinéen" },
  { "code": "GY", "nationality": "Guyanais" },
  { "code": "HT", "nationality": "Haïtien" },
  { "code": "HN", "nationality": "Hondurien" },
  { "code": "HU", "nationality": "Hongrois" },
  { "code": "IS", "nationality": "Islandais" },
  { "code": "IN", "nationality": "Indien" },
  { "code": "ID", "nationality": "Indonésien" },
  { "code": "IR", "nationality": "Iranien" },
  { "code": "IQ", "nationality": "Irakien" },
  { "code": "IE", "nationality": "Irlandais" },
  { "code": "IL", "nationality": "Israélien" },
  { "code": "IT", "nationality": "Italien" },
  { "code": "JM", "nationality": "Jamaïcain" },
  { "code": "JP", "nationality": "Japonais" },
  { "code": "JO", "nationality": "Jordanien" },
  { "code": "KZ", "nationality": "Kazakhstanais" },
  { "code": "KE", "nationality": "Kényan" },
  { "code": "KR", "nationality": "Sud-Coréen" },
  { "code": "KW", "nationality": "Koweïtien" },
  { "code": "KG", "nationality": "Kirghiz" },
  { "code": "LA", "nationality": "Laotien" },
  { "code": "LV", "nationality": "Letton" },
  { "code": "LB", "nationality": "Libanais" },
  { "code": "LS", "nationality": "Lesothan" },
  { "code": "LR", "nationality": "Libérien" },
  { "code": "LY", "nationality": "Libyen" },
  { "code": "LT", "nationality": "Lituanien" },
  { "code": "LU", "nationality": "Luxembourgeois" },
  { "code": "MG", "nationality": "Malgache" },
  { "code": "MW", "nationality": "Malawien" },
  { "code": "MY", "nationality": "Malaisien" },
  { "code": "MV", "nationality": "Maldivien" },
  { "code": "ML", "nationality": "Malien" },
  { "code": "MT", "nationality": "Maltais" },
  { "code": "MR", "nationality": "Mauritanien" },
  { "code": "MU", "nationality": "Mauricien" },
  { "code": "MX", "nationality": "Mexicain" },
  { "code": "MD", "nationality": "Moldave" },
  { "code": "MC", "nationality": "Monégasque" },
  { "code": "MN", "nationality": "Mongol" },
  { "code": "MA", "nationality": "Marocain" },
  { "code": "MZ", "nationality": "Mozambicain" },
  { "code": "MM", "nationality": "Birman" },
  { "code": "NA", "nationality": "Namibien" },
  { "code": "NP", "nationality": "Népalais" },
  { "code": "NL", "nationality": "Néerlandais" },
  { "code": "NZ", "nationality": "Néo-Zélandais" },
  { "code": "NI", "nationality": "Nicaraguayen" },
  { "code": "NE", "nationality": "Nigérien" },
  { "code": "NG", "nationality": "Nigerian" },
  { "code": "NO", "nationality": "Norvégien" },
  { "code": "OM", "nationality": "Omanais" },
  { "code": "PK", "nationality": "Pakistanais" },
  { "code": "PA", "nationality": "Panaméen" },
  { "code": "PG", "nationality": "Papouasien-Néo-Guinéen" },
  { "code": "PY", "nationality": "Paraguayen" },
  { "code": "PE", "nationality": "Péruvien" },
  { "code": "PH", "nationality": "Philippin" },
  { "code": "PL", "nationality": "Polonais" },
  { "code": "PT", "nationality": "Portugais" },
  { "code": "QA", "nationality": "Qatari" },
  { "code": "RO", "nationality": "Roumain" },
  { "code": "RU", "nationality": "Russe" },
  { "code": "RW", "nationality": "Rwandais" },
  { "code": "SA", "nationality": "Saoudien" },
  { "code": "SN", "nationality": "Sénégalais" },
  { "code": "RS", "nationality": "Serbe" },
  { "code": "SG", "nationality": "Singapourien" },
  { "code": "SK", "nationality": "Slovaque" },
  { "code": "SI", "nationality": "Slovène" },
  { "code": "SO", "nationality": "Somalien" },
  { "code": "ZA", "nationality": "Sud-Africain" },
  { "code": "ES", "nationality": "Espagnol" },
  { "code": "LK", "nationality": "Sri-Lankais" },
  { "code": "SD", "nationality": "Soudanais" },
  { "code": "SE", "nationality": "Suédois" },
  { "code": "CH", "nationality": "Suisse" },
  { "code": "SY", "nationality": "Syrien" },
  { "code": "TW", "nationality": "Taïwanais" },
  { "code": "TJ", "nationality": "Tadjik" },
  { "code": "TZ", "nationality": "Tanzanien" },
  { "code": "TH", "nationality": "Thaïlandais" },
  { "code": "TG", "nationality": "Togolais" },
  { "code": "TT", "nationality": "Trinidadien ou Tobagonien" },
  { "code": "TN", "nationality": "Tunisien" },
  { "code": "TR", "nationality": "Turc" },
  { "code": "TM", "nationality": "Turkmène" },
  { "code": "UG", "nationality": "Ougandais" },
  { "code": "UA", "nationality": "Ukrainien" },
  { "code": "AE", "nationality": "Émirati" },
  { "code": "GB", "nationality": "Britannique" },
  { "code": "US", "nationality": "Américain" },
  { "code": "UY", "nationality": "Uruguayen" },
  { "code": "UZ", "nationality": "Ouzbek" },
  { "code": "VE", "nationality": "Vénézuélien" },
  { "code": "VN", "nationality": "Vietnamien" },
  { "code": "YE", "nationality": "Yéménite" },
  { "code": "ZM", "nationality": "Zambien" },
  { "code": "ZW", "nationality": "Zimbabwéen" }
]

